import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { connectState } from '@examdojo/angular/util';
import { ColorSchemeService } from '@examdojo/browser/color-scheme';
import { UserQuery } from '@examdojo/user';
import { SidebarProfileLinkComponent, SidenavItem } from '@examdojo/shell';
import { ModalController } from '@ionic/angular/standalone';
import { TranslocoPipe } from '@jsverse/transloco';
import { MOBILE_MENU_SHEET_DIALOG_ID } from './mobile-menu-sheet-dialog.model';

@Component({
  selector: 'dojo-mobile-menu-sheet-dialog',
  imports: [RouterLink, RouterLinkActive, TranslocoPipe, SidebarProfileLinkComponent],
  templateUrl: './mobile-menu-sheet-dialog.component.html',
  styleUrl: './mobile-menu-sheet-dialog.component.scss',
  host: { class: 'is-mobile' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileMenuSheetDialogComponent {
  constructor(
    private readonly modalController: ModalController,
    private readonly router: Router,
    private readonly userQuery: UserQuery,
    private readonly colorSchemeService: ColorSchemeService,
  ) {}

  readonly items = input.required<SidenavItem[]>();
  readonly settingsRoute = input.required<string>();

  readonly state = connectState({
    user: this.userQuery.active$,
    darkMode: this.colorSchemeService.hasDarkMode$,
  });

  navigateToRoute(route: string) {
    this.router.navigate([route]);
    this.modalController.dismiss(undefined, undefined, MOBILE_MENU_SHEET_DIALOG_ID);
  }

  navigateToSettings() {
    this.router.navigate([this.settingsRoute()]);
    this.modalController.dismiss(undefined, undefined, MOBILE_MENU_SHEET_DIALOG_ID);
  }
}
